/*
 * @description: It Contain action types.
 */

export const IS_FETCHING = "IS_FETCHING";

/************ User *************/
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGOUT = "USER_LOGOUT";

/************ Employee *************/
export const GET_ALL_EMPLOYEE_SUCCESS = "GET_ALL_EMPLOYEE_SUCCESS";
export const GET_ALL_EMPLOYEE_FAIL = "GET_ALL_EMPLOYEE_FAIL";
export const CREATE_EMPLOYEE_SUCCESS = "CREATE_EMPLOYEE_SUCCESS";
export const CREATE_EMPLOYEE_FAIL = "CREATE_EMPLOYEE_FAIL";
export const ACTIVATE_DEACTIVATE_EMPLOYEE_SUCCESS = "ACTIVATE_DEACTIVATE_EMPLOYEE_SUCCESS";
export const ACTIVATE_DEACTIVATE_EMPLOYEE_FAIL = "ACTIVATE_DEACTIVATE_EMPLOYEE_FAIL";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";
export const UPDATE_EMPLOYEE_FAIL = "UPDATE_EMPLOYEE_FAIL";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE_FAIL = "DELETE_EMPLOYEE_FAIL";
export const GET_EMPLOYEE_BY_ID_SUCCESS = "GET_EMPLOYEE_BY_ID_SUCCESS";
export const GET_EMPLOYEE_BY_ID_FAIL = "GET_EMPLOYEE_BY_ID_FAIL";
export const GET_EMPLOYEE_ROLE_SUCCESS = "GET_EMPLOYEE_ROLE_SUCCESS";
export const GET_EMPLOYEE_ROLE_FAIL = "GET_EMPLOYEE_ROLE_FAIL";

/************ Customer *************/
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL";
export const GET_CUSTOMER_BY_ID_SUCCESS = "GET_CUSTOMER_BY_ID_SUCCESS";
export const GET_CUSTOMER_BY_ID_FAIL = "GET_CUSTOMER_BY_ID_FAIL";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";
export const ACTIVATE_DEACTIVATE_CUSTOMER_SUCCESS = "ACTIVATE_DEACTIVATE_CUSTOMER_SUCCESS";
export const ACTIVATE_DEACTIVATE_CUSTOMER_FAIL = "ACTIVATE_DEACTIVATE_CUSTOMER_FAIL";

/************ Post *************/
export const CREATE_POST_ACTION = "CREATE_POST_ACTION";
export const CONFIRMED_CREATE_POST_ACTION = "CONFIRMED_CREATE_POST_ACTION";
export const GET_POSTS = "GET_POSTS";
export const CONFIRMED_GET_POSTS = "CONFIRMED_GET_POSTS";
export const EDIT_POST_ACTION = "EDIT_POST_ACTION";
export const CONFIRMED_EDIT_POST_ACTION = "CONFIRMED_EDIT_POST_ACTION";
export const CONFIRMED_DELETE_POST_ACTION = "CONFIRMED_DELETE_POST_ACTION";

/************ Transaction *************/
export const GET_ALL_TRANSACTION_SUCCESS = "GET_ALL_TRANSACTION_SUCCESS";
export const GET_ALL_TRANSACTION_FAIL = "GET_ALL_TRANSACTION_FAIL";
export const GET_TRANSACTION_BY_ID_SUCCESS = "GET_TRANSACTION_BY_ID_SUCCESS";
export const GET_TRANSACTION_BY_ID_FAIL = "GET_TRANSACTION_BY_ID_FAIL";

/************ Notification *************/
export const GET_ALL_NOTIFICATION_SUCCESS = "GET_ALL_NOTIFICATION_SUCCESS";
export const GET_ALL_NOTIFICATION_FAIL = "GET_ALL_NOTIFICATION_FAIL";
export const CREATE_NOTIFICATION_SUCCESS = "CREATE_NOTIFICATION_SUCCESS";
export const CREATE_NOTIFICATION_FAIL = "CREATE_NOTIFICATION_FAIL";
export const GET_NOTIFICATION_BY_ID_SUCCESS = "GET_NOTIFICATION_BY_ID_SUCCESS";
export const GET_NOTIFICATION_BY_ID_FAIL = "GET_NOTIFICATION_BY_ID_FAIL";

/************ Dashboard *************/

/************ Current Gold Price *************/
export const GET_CURRENT_GOLD_PRICE_SUCCESS = "GET_CURRENT_GOLD_PRICE_SUCCESS";
export const GET_CURRENT_GOLD_PRICE_FAIL = "GET_CURRENT_GOLD_PRICE_FAIL";

/************ Historical Gold Price *************/
export const GET_HISTORICAL_GOLD_PRICE_SUCCESS = "GET_HISTORICAL_GOLD_PRICE_SUCCESS";
export const GET_HISTORICAL_GOLD_PRICE_FAIL = "GET_HISTORICAL_GOLD_PRICE_FAIL";

/************ Get All Active Customer *************/
export const GET_TOTAL_ACTIVE_CUSTOMER_SUCCESS = "GET_TOTAL_ACTIVE_CUSTOMER_SUCCESS";
export const GET_TOTAL_ACTIVE_CUSTOMER_FAIL = "GET_TOTAL_ACTIVE_CUSTOMER_FAIL";

/************ Get All Active Customer *************/
export const GET_TOTAL_SALES_SUCCESS = "GET_TOTAL_SALES_SUCCESS";
export const GET_TOTAL_SALES_FAIL = "GET_TOTAL_SALES_FAIL";

/************ Get Reward Received *************/
export const GET_REWARD_RECEIVED_SUCCESS = "GET_REWARD_RECEIVED_SUCCESS";
export const GET_REWARD_RECEIVED_FAIL = "GET_REWARD_RECEIVED_FAIL";

/************ Get Reward Redemed *************/
export const GET_REWARD_REDEEM_SUCCESS = "GET_REWARD_REDEEM_SUCCESS";
export const GET_REWARD_REDEEM_FAIL = "GET_REWARD_REDEEM_FAIL";

/************ Get Recent Customers *************/
export const GET_RECENT_CUSTOMERS_SUCCESS = "GET_RECENT_CUSTOMERS_SUCCESS";
export const GET_RECENT_CUSTOMERS_FAIL = "GET_RECENT_CUSTOMERS_FAIL";

/************ Get Recent Transaction*************/
export const GET_RECENT_TRANSACTION_SUCCESS = "GET_RECENT_TRANSACTION_SUCCESS";
export const GET_RECENT_TRANSACTION_FAIL = "GET_RECENT_TRANSACTION_FAIL";

/************ Get Sales History*************/
export const GET_SALES_HISTORY_SUCCESS = "GET_SALES_HISTORY_SUCCESS";
export const GET_SALES_HISTORY_FAIL = "GET_SALES_HISTORY_FAIL";

/************ Roles *************/
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAIL = "GET_ALL_ROLES_FAIL";

/************ Reports *************/
export const GET_DAILY_CUSTOMER_POINT_REPORT_SUCCESS = "GET_DAILY_CUSTOMER_POINT_REPORT_SUCCESS";
export const GET_DAILY_CUSTOMER_POINT_REPORT_FAIL = "GET_DAILY_CUSTOMER_POINT_REPORT_FAIL";
export const GET_REWARD_REDEEM_REPORT_SUCCESS = "GET_REWARD_REDEEM_REPORT_SUCCESS";
export const GET_REWARD_REDEEM_REPORT_FAIL = "GET_REWARD_REDEEM_REPORT_FAIL";
export const GET_SUBSCRIBED_CUSTOMER_REPORT_SUCCESS = "GET_SUBSCRIBED_CUSTOMER_REPORT_SUCCESS";
export const GET_SUBSCRIBED_CUSTOMER_REPORT_FAIL = "GET_SUBSCRIBED_CUSTOMER_REPORT_FAIL";
export const GET_CUSTOMER_REPORT_SUCCESS = "GET_CUSTOMER_REPORT_SUCCESS";
export const GET_CUSTOMER_REPORT_FAIL = "GET_CUSTOMER_REPORT_FAIL";
export const GET_OFFLINE_GOLD_TRANSACTION_REPORT_SUCCESS = "GET_OFFLINE_GOLD_TRANSACTION_REPORT_SUCCESS";
export const GET_OFFLINE_GOLD_TRANSACTION_REPORT_FAIL = "GET_OFFLINE_GOLD_TRANSACTION_REPORT_FAIL";
export const GET_SUBSCRIPTION_REPORT_SUCCESS = "GET_SUBSCRIPTION_REPORT_SUCCESS";
export const GET_SUBSCRIPTION_REPORT_FAIL = "GET_SUBSCRIPTION_REPORT_FAIL";
export const GET_ALL_TRANSACTION_REPORT_SUCCESS = "GET_ALL_TRANSACTION_REPORT_SUCCESS";
export const GET_ALL_TRANSACTION_REPORT_FAIL = "GET_ALL_TRANSACTION_REPORT_FAIL";
export const CLEAR_OFFLINE_GOLD_PURCHASE = "CLEAR_OFFLINE_GOLD_PURCHASE";


/************ Instore Request *************/
export const GET_ALL_REQUESTS_SUCCESS = "GET_ALL_REQUESTS_SUCCESS";
export const GET_ALL_REQUESTS_FAIL = "GET_ALL_REQUESTS_FAIL";
export const CREATE_ACCEPT_REQUEST_SUCCESS = "CREATE_ACCEPT_REQUEST_SUCCESS";
export const CREATE_ACCEPT_REQUEST_FAIL = "CREATE_ACCEPT_REQUEST_FAIL";

